<script lang="ts">
  import { formatCurrency } from "../utils";

  export let amount: number;
  export let locale: string = "fi";

  $: displayValue = formatCurrency(amount, locale);
</script>

<span>
  {displayValue}
</span>
